import { z } from '@bonanza-social/toolkit/api';

export const TransactionItemSchema = z.object({
  transactionId: z.number(),
  amount: z.number(),
  currency: z.string(),
  transactionType: z.string(),
  status: z.string(),
  createdAt: z.string().datetime(),
  isCancelable: z.boolean(),
  provider: z.string().optional(),
  paymentMethodType: z.string().optional(),
  paymentMethodDetails: z.string().optional(),
  paymentMethodDocumentStatus: z.string().optional(),
  reason: z.string().optional(),
  paymentMethodVendor: z.string().optional(),
});

export const SessionItemSchema = z.object({
  id: z.number(),
  loginDateTime: z.string().datetime(),
  logoutDateTime: z.string().datetime().optional(),
  loginBalance: z.number(),
  totalBets: z.number().optional(),
  totalWins: z.number().optional(),
  netPosition: z.number().optional(),
  logoutBalance: z.number().optional(),
});

export const GamingItemSchema = z.object({
  roundId: z.number(),
  gameId: z.number(),
  createdAt: z.string().datetime(),
  totalBets: z.number(),
  totalWins: z.number(),
  source: z.string(),
  isFreeSpinRound: z.boolean(),
});

export const HistoryRequestSchema = z.object({
  pageSize: z.number(),
  pageNumber: z.number(),
  startDate: z.string(),
});

export const HistorySharedResponseSchema = z.object({
  pageNumber: z.number(),
  hasNextPage: z.boolean(),
});

export const TransactionHistoryResponseSchema =
  HistorySharedResponseSchema.extend({
    hasPaymentMethodsAwaitingDocumentReview: z.boolean(),
    hasPaymentMethodsWithRequiredDocumentVerification: z.boolean(),
    items: z.array(TransactionItemSchema),
  });

export const GamingHistoryResponseSchema = HistorySharedResponseSchema.extend({
  items: z.array(GamingItemSchema),
});

export const SessionHistoryResponseSchema = HistorySharedResponseSchema.extend({
  items: z.array(SessionItemSchema),
});
